import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
import "./Healthinsurance.css";
import Overview from "./Overview";

const HealthInsurance = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    emailId: "",
    dateOfBirth: "",
    city: "",
    medicalCondition: "",
    smoker: "",
    numberOfAdults: "1",
    numberOfChildren: "0",
    coverageAmount: "500000",
    termsAccepted: false,
  });

  const [validated, setValidated] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const resetForm = () => {
    setFormData({
      fullName: "",
      mobileNumber: "",
      emailId: "",
      dateOfBirth: "",
      city: "",
      medicalCondition: "",
      smoker: "",
      numberOfAdults: "1",
      numberOfChildren: "0",
      coverageAmount: "500000",
      termsAccepted: false,
    });
    setValidated(false);
    setShowSuccess(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      try {
        // 👇 Call your API here
        const response = await fetch("https://your-api-url.com/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        console.log("Form data submitted successfully:", formData);
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          resetForm();
        }, 3000);
      } catch (error) {
        console.error("Error submitting form data:", error);
      }
    }
    setValidated(true);
  };
  const insurances = ["HDFC"];

  const cities = [
    "Bangalore",
    "Mumbai",
    "Delhi",
    "Chennai",
    "Hyderabad",
    "Kolkata",
    "Pune",
  ];
  const medicalConditions = [
    "None",
    "Diabetes",
    "Hypertension",
    "Asthma",
    "Heart Disease",
    "Others",
  ];
  const coverageAmounts = [
    { value: "300000", display: "₹3,00,000" },
    { value: "500000", display: "₹5,00,000" },
    { value: "1000000", display: "₹10,00,000" },
    { value: "2000000", display: "₹20,00,000" },
    { value: "5000000", display: "₹50,00,000" },
  ];

  return (
    <>
      <Navbar />
      <div className="main-box">
        <div className="row ">
          <div className="main-box-ss">
            <div className="col-12 col-md-12">
              <section className="insurance-service position-relative overflow-hidden">
                <div className="radial-bg"></div>
                <div
                  className="insurance position-relative"
                  style={{ zIndex: 1 }}
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-12 d-flex justify-content-end pt-3 px-3 px-md-5"></div>
                    </div>

                    <div
                      className="row justify-content-center align-items-center text-center"
                     
                    >
                      <div className="col-12 mb-3 mt-5 pb-0">
                        <h2 className="fw-bold carloan-text-1 mb-2 ">
                          Health Insurance
                        </h2>
                        <p className="mb-4">
                          Please fill all the details Health Insurance
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="position-absolute top-0 start-0 w-100 h-100"
                  style={{
                    filter: "blur(88px)",
                    zIndex: 0,
                  }}
                ></div>
                <section className="bg">
                  <div className="container mt-5 mt-lg-0">
                    <div className="row mb-4 justify-content-center ">
                      <div className="col-12 col-lg-12">
                        <div className="card  card_top  bg-light border-0  ">
                          <div
                            className="card-body   bg-light"
                            style={{
                              borderTopLeftRadius: "10px",
                              borderTopRightRadius: "10px",
                              borderBottomLeftRadius: "10px",
                              borderBottomRightRadius: "10px",
                            }}
                          >
                            {showSuccess && (
                              <div className="alert alert-success" role="alert">
                                Your health insurance application has been
                                submitted successfully!
                              </div>
                            )}

                            <form
                              className={validated ? "was-validated" : ""}
                              noValidate
                              validated={validated}
                              onSubmit={handleSubmit}
                            >
                              {/* Personal Details Section */}
                              <div className="card mb-4 ">
                                <div className="card-body">
                                  <h5 className="mb-4">Personal Details</h5>
                                  <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="form-group">
                                        <label htmlFor="fullName">
                                          Full Name
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="fullName"
                                          name="fullName"
                                          placeholder="Enter full name"
                                          value={formData.fullName}
                                          onChange={handleChange}
                                          required
                                        />
                                        <div className="invalid-feedback">
                                          Please provide your full name.
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="form-group">
                                        <label htmlFor="mobileNumber">
                                          Mobile Number
                                        </label>
                                        <input
                                          type="tel"
                                          className="form-control"
                                          id="mobileNumber"
                                          name="mobileNumber"
                                          placeholder="Enter mobile number"
                                          value={formData.mobileNumber}
                                          onChange={handleChange}
                                          pattern="[0-9]{10}"
                                          required
                                        />
                                        <div className="invalid-feedback">
                                          Please provide a valid 10-digit mobile
                                          number.
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="form-group">
                                        <label htmlFor="emailId">
                                          Email Address
                                        </label>
                                        <input
                                          type="email"
                                          className="form-control"
                                          id="emailId"
                                          name="emailId"
                                          placeholder="Enter email address"
                                          value={formData.emailId}
                                          onChange={handleChange}
                                          required
                                        />
                                        <div className="invalid-feedback">
                                          Please provide a valid email address.
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="form-group">
                                        <label htmlFor="dateOfBirth">
                                          Date of Birth
                                        </label>
                                        <input
                                          type="date"
                                          className="form-control"
                                          id="dateOfBirth"
                                          name="dateOfBirth"
                                          value={formData.dateOfBirth}
                                          onChange={handleChange}
                                          required
                                        />
                                        <div className="invalid-feedback">
                                          Please provide your date of birth.
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="form-group">
                                        <label htmlFor="city">
                                          City of Residence
                                        </label>
                                        <select
                                          className="form-select"
                                          id="city"
                                          name="city"
                                          value={formData.city}
                                          onChange={handleChange}
                                          required
                                        >
                                          <option value="">Select</option>
                                          {cities.map((city, idx) => (
                                            <option key={idx} value={city}>
                                              {city}
                                            </option>
                                          ))}
                                        </select>
                                        <div className="invalid-feedback">
                                          Please select your city of residence.
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="form-group">
                                        <label htmlFor="insurance">
                                          Insurance Type
                                        </label>
                                        <select
                                          className="form-select"
                                          id="insurance"
                                          name="insurance"
                                          value={formData.insurance}
                                          onChange={handleChange}
                                          required
                                        >
                                          <option value="">Select</option>
                                          {insurances.map((insurance, idx) => (
                                            <option key={idx} value={insurance}>
                                              {insurance}
                                            </option>
                                          ))}
                                        </select>
                                        <div className="invalid-feedback">
                                          Please select your insurance type.
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Health Details Section */}
                              <div className="card mb-4 ">
                                <div className="card-body">
                                  <h5 className="mb-4">Health Details</h5>
                                  <div className="row align-items-center">
                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="form-group mb-0">
                                        <label htmlFor="medicalCondition">
                                          Medical Condition
                                        </label>
                                        <select
                                          className="form-select"
                                          id="medicalCondition"
                                          name="medicalCondition"
                                          value={formData.medicalCondition}
                                          onChange={handleChange}
                                          required
                                        >
                                          <option value="">Select</option>
                                          {medicalConditions.map(
                                            (condition, index) => (
                                              <option
                                                key={index}
                                                value={condition}
                                              >
                                                {condition}
                                              </option>
                                            )
                                          )}
                                        </select>
                                        <div className="invalid-feedback">
                                          Please select your medical condition.
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="form-group mb-0">
                                        <label className="form-label d-block">
                                          Are you a smoker?
                                        </label>
                                        <div className="d-flex gap-3">
                                          <div className="form-check">
                                            <input
                                              type="radio"
                                              className="form-check-input"
                                              id="smokerYes"
                                              name="smoker"
                                              value="yes"
                                              checked={
                                                formData.smoker === "yes"
                                              }
                                              onChange={handleChange}
                                              required
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="smokerYes"
                                            >
                                              Yes
                                            </label>
                                          </div>
                                          <div className="form-check">
                                            <input
                                              type="radio"
                                              className="form-check-input"
                                              id="smokerNo"
                                              name="smoker"
                                              value="no"
                                              checked={formData.smoker === "no"}
                                              onChange={handleChange}
                                              required
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="smokerNo"
                                            >
                                              No
                                            </label>
                                          </div>
                                        </div>
                                        <div className="invalid-feedback">
                                          Please select an option.
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Coverage Details Section */}
                              <div className="card mb-4 ">
                                <div className="card-body">
                                  <h5 className="mb-4">Coverage Details</h5>
                                  <div className="row">
                                    <div className="col-12 col-md-4 mb-3">
                                      <div className="form-group">
                                        <label htmlFor="numberOfAdults">
                                          Number of Adults
                                        </label>
                                        <select
                                          className="form-select"
                                          id="numberOfAdults"
                                          name="numberOfAdults"
                                          value={formData.numberOfAdults}
                                          onChange={handleChange}
                                          required
                                        >
                                          {["1", "2", "3", "4"].map(
                                            (option, idx) => (
                                              <option key={idx} value={option}>
                                                {option}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-4 mb-3">
                                      <div className="form-group">
                                        <label htmlFor="numberOfChildren">
                                          Number of Children
                                        </label>
                                        <select
                                          className="form-select"
                                          id="numberOfChildren"
                                          name="numberOfChildren"
                                          value={formData.numberOfChildren}
                                          onChange={handleChange}
                                          required
                                        >
                                          {["0", "1", "2", "3", "4"].map(
                                            (option, idx) => (
                                              <option key={idx} value={option}>
                                                {option}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-4 mb-3">
                                      <div className="form-group">
                                        <label htmlFor="coverageAmount">
                                          Coverage Amount
                                        </label>
                                        <select
                                          className="form-select"
                                          id="coverageAmount"
                                          name="coverageAmount"
                                          value={formData.coverageAmount}
                                          onChange={handleChange}
                                          required
                                        >
                                          {coverageAmounts.map(
                                            (option, idx) => (
                                              <option
                                                key={idx}
                                                value={option.value}
                                              >
                                                {option.display}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Terms and Conditions */}
                              <div className="row">
                                <div className="col-12">
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="termsAccepted"
                                      name="termsAccepted"
                                      checked={formData.termsAccepted}
                                      onChange={handleChange}
                                      required
                                    />
                                    <span>
                                      By submitting the application, I agree and
                                      accept the Terms and Conditions as
                                      specified{" "}
                                      <a href="/" className="text-primary">
                                        here
                                      </a>
                                    </span>
                                    <div className="invalid-feedback">
                                      You must accept the terms and conditions.
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-12">
                                  <button
                                    type="submit"
                                    className="btn btn-primary btn-m py-2"
                                  >
                                    Apply
                                  </button>
                                  &nbsp;&nbsp;&nbsp;
                                  <button
                                    className="btn btn-primary py-2 btn-m"
                                    onClick={resetForm}
                                  >
                                    Clear
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Overview />
      <Explore />
      <Footer />
    </>
  );
};

export default HealthInsurance;
